// What the Settings page's product mutations send to POST /api/products and
// PATCH /api/products/:id.

/** The "Also known as" field's comma-separated text → the alias array the API takes (it normalizes and caps). */
export function aliasesTextToArray(text: string | undefined): string[] {
  return (text ?? "")
    .split(",")
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
}

/**
 * The body of the Settings page's PATCH /api/products/:id.
 *
 * An `aliases` array in that PATCH is the product's whole list of active aliases:
 * the server deletes every active alias the array leaves out (agent suggestions
 * awaiting approval are kept). So aliases go only when the caller has them. The
 * product dialog always does — its field's text, where an emptied field is an empty
 * array that clears them. The drag-and-drop category move has none and sends no
 * `aliases` key; it used to send [], which deleted the buyer nicknames that product
 * search and the SMS agent match on.
 */
export function productPatchBody<T extends { aliases?: string }>(data: T) {
  const { aliases, ...rest } = data;
  return aliases === undefined ? rest : { ...rest, aliases: aliasesTextToArray(aliases) };
}
